import { HorizontalSteps } from 'components/molecules/HorizontalSteps';
import { TutorPlanCard } from 'components/molecules/TutorPlan/TutorPlanCard';
import NavigationPrompt from 'components/NavigationPrompt';
import { PaperCardTemplate } from 'components/templates/PaperCardTemplate';
import { TutorContractPlanCreditCard } from 'components/TutorContractPlan/TutorContractPlanCreditCard';
import { TutorContractPlanHeader } from 'components/TutorContractPlan/TutorContractPlanHeader';
import { TutorPlanOrderResume } from 'components/TutorRegistration/TutorPlanOrderResume';
import { useTutorUserPlan } from 'context';
import React from 'react';
import { useWatch } from 'react-hook-form';

import { Box, Container, Grid, Toolbar } from '@mui/material';
import { BillingAddressForm } from 'components/Forms/TutorForm/BillingAddressForm';

const STEPS = ['Pagamento', 'Endereço de Cobrança', 'Resumo'];

export const TutorContractPlanPage: React.FC = () => {
  document.title = 'Vet4all - Tutor';

  const { form, loading, plans, resume } = useTutorUserPlan();

  const activeStep = useWatch({ control: form.control, name: 'activeStep' });

  const steps = [
    <TutorContractPlanCreditCard />,
    <BillingAddressForm />,
    <TutorPlanOrderResume resume={resume} />,
  ];

  return (
    <Box sx={{ display: 'flex' }}>
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          height: '100vh',
          overflow: 'auto',
        }}
      >
        <Toolbar />

        <Container sx={{ py: 3 }} maxWidth="xl">
          <NavigationPrompt block={form.formState.isDirty} />

          <Grid container spacing={5}>
            <Grid item xs={12} lg={8}>
              <PaperCardTemplate loading={loading} childrenProps={{ px: 6 }}>
                <TutorContractPlanHeader />

                <HorizontalSteps steps={STEPS} />

                {steps[activeStep]}
              </PaperCardTemplate>
            </Grid>

            <Grid item xs={12} lg={4}>
              <TutorPlanCard plan={plans[0]} />
            </Grid>
          </Grid>
        </Container>
      </Box>
    </Box>
  );
};
